// src/app/views/staking/Staking.tsx

'use client';
import React from 'react';
import styles from './Staking.module.scss';
import TerminalHeader from '../terminal-header/TerminalHeader';
import { useUIContext } from '@/context/UIContext';
import NFT from '../nft/Nft';

const Staking: React.FC = () => {
  const { setActiveButton, setNftIcon, setStakingIcon, setScreenContent } =
    useUIContext();

  const handleNftLinkClick = () => {
    setScreenContent(<NFT />);
    setActiveButton(`nft`);
    setNftIcon(`/terminal-keys/nft-pressed.webp`);
    setStakingIcon(`/terminal-keys/staking-rest.webp`);
  };

  return (
    <div className={styles.staking}>
      {/* Header Section */}
      <TerminalHeader />

      {/* Title (reserved) */}
      <h2 className={styles['staking__title']}></h2>

      {/* Introductory Paragraph */}
      <p className={styles['staking__paragraph']}>{`Coming Soon`}</p>
    </div>
  );
};

export default Staking;
